<template>
    <div style="padding-bottom: 100px;background: #f7f6fb;">
        <div class="top-box">
            <!-- 第一行：左右结构，左边用户头像，右边名称+手机号（两行） -->
            <div class="user-info-row">
                <div class="avatar" @click="handleAvatarClick">
                    <img :src="userAvatar" alt="头像" />
                </div>
                <div class="user-details">
                    <div class="user-name">{{ userName }}</div>
                    <div class="user-phone">{{ userPhone }}</div>
                </div>
            </div>
            <!-- 第二行：可用积分 & 可用抵用券（左右排布，数字+名称） -->
            <div class="stat-card">
                <div class="stat-box">
                    <div class="stat-number">{{ points }}</div>
                    <div class="stat-label">可用积分</div>
                </div>
                <div class="stat-box">
                    <div class="stat-number">{{ coupons }}</div>
                    <div class="stat-label">可用抵用券</div>
                </div>
            </div>
        </div>
        <div class="user-page">
            <!-- 第三行：订单状态 (待支付、待发货、待收货、退款/售后、全部订单) 图片+文字 -->
            <div class="order-status-row">
                <div v-for="item in orderStatusList" :key="item.key" class="order-item"
                    @click="handleOrderClick(item.key)">
                    <img :src="'/static/user/' + item.icon" class="order-icon" alt="" />
                    <span class="order-text">{{ item.label }}</span>
                </div>
            </div>

            <!-- 第四行：功能区 (联系客服、收藏、推广海报、地址管理) -->
            <div class="function-row">
                <div v-for="func in functionList" :key="func.key" class="function-item"
                    @click="handleFunctionClick(func.key)">
                    <img :src="'/static/user/' + func.icon" class="func-icon" alt="" />
                    <span class="func-text">{{ func.label }}</span>
                </div>
            </div>

            <!-- 第五行：积分商城图片横幅 -->
            <div class="points-mall-banner" @click="goToPointsMall">
                <img src="/static/cate/shop.png" alt="积分商城"
                    style="width: 100%; height: 100px; margin-bottom: 3px; display: block;" />
            </div>

            <!-- 第六行：你可能想买标题 -->
            <div class="section-title">
                <span style="margin-right: 8px;">—</span>
                <img src="/static/user/xihuan.png" alt="" class="section-icon">
                <span class="title-text">你可能想买</span>
                <span style="margin-left: 8px;">—</span>
            </div>

            <!-- 第七行：商品列表，一行两个，使用与首页相同的卡片样式 -->
            <div class="goods-grid">
                <div v-for="item in productList" :key="item.id" class="product-card" @click="goToDetail()">
                    <img :src="item.image" class="product-img" alt="" />
                    <div class="product-info">
                        <div class="product-title">{{ item.title }}</div>
                        <div class="product-desc">{{ item.desc }}</div>
                        <!-- 价格区域，与首页完全一致的逻辑 -->
                        <div class="price-row">
                            <div
                                :style="item.points && item.price ? 'display: flex;flex-wrap: nowrap;align-items: flex-end;' : ''">
                                <span class="current-price" v-if="item.points">{{ item.points }}<span
                                        style="font-size: 10px;">积分</span></span>
                                <span style="font-size: 10px; color:#ff3b2f; margin: 0 4px;line-height: 1.5;"
                                    v-if="item.price && item.points">+</span>
                                <span class="current-price" v-if="item.price"><span style="font-size: 10px;">¥</span>{{
                                    item.price }}</span>
                                <span class="old-price" v-if="item.oldPrice">¥{{ item.oldPrice }}</span>
                            </div>
                            <div class="add" @click.stop="addToCart(item)">+</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserCenter',
    data() {
        return {
            // 用户信息
            userName: '胡二三',
            userPhone: '152****2251',
            userAvatar: '/static/user-logo.png',
            points: 0,
            coupons: 0,

            // 订单状态列表
            orderStatusList: [
                { key: 'pendingPay', label: '待支付', icon: 'one.png' },
                { key: 'pendingShip', label: '待发货', icon: 'two.png' },
                { key: 'pendingReceive', label: '待收货', icon: 'three.png' },
                { key: 'refund', label: '退款/售后', icon: 'four.png' },
                { key: 'allOrders', label: '全部订单', icon: 'five.png' }
            ],

            // 功能区列表
            functionList: [
                { key: 'service', label: '联系客服', icon: 'service.png' },
                { key: 'favorite', label: '收藏', icon: 'favorite.png' },
                { key: 'poster', label: '推广海报', icon: 'poster.png' },
                { key: 'address', label: '地址管理', icon: 'address.png' }
            ],

            // 商品列表数据，包含points字段以支持积分+价格组合，与首页数据结构一致
            productList: [
                { id: 17, title: '荣事达电煮锅一体锅多功能电炒锅家用火锅电锅蒸煮炒煎电热火锅', desc: '加热块 | 更方便快捷', price: '69.90', oldPrice: '109', image: '/static/home/Rectangle 1384.png', path: '/detail' },
                { id: 18, title: '小熊蒸蛋器2025新款自动断电煮蛋器家用小型蒸锅一体玉米鸡蛋神器', desc: '可蒸煮 | 一键易操作', points: '550', price: '38.8', image: '/static/home/zhengdan.png', path: '/detail' },
                { id: 19, title: '小熊养生壶炖煮一体煮茶壶2026新款保温家用烧水壶官方旗舰店正品', desc: '0胶水更安心 | 入口安全有保障', points: '3793', oldPrice: '79.90', image: '/static/home/zhucha.png', path: '/detail' },
                { id: 20, title: '法国红酒整箱干红葡萄酒赤霞珠红酒14度官方正品旗舰店礼盒装送礼', desc: '果香浓郁 | 口感顺滑', points: '1620', oldPrice: '18.4', image: '/static/home/hongjiu.png', path: '/detail' },
                { id: 21, title: 'SHAREDNOTES生椰莫斯卡托甜白葡萄酒北欧风浮雕瓶椰子果酒6度微醺', desc: '椰子果香 | 清爽不腻', points: '550', price: '9.9', image: '/static/home/tianjiu.png', path: '/detail' },
            ]
        };
    },
    methods: {
        handleAvatarClick() {
            console.log('点击头像，可跳转个人资料');
        },
        handleOrderClick(orderKey) {
            console.log(`点击订单状态: ${orderKey}`);

            // 构建状态映射关系
            const statusMap = {
                'pendingPay': 'pendingPay',    // 待支付
                'pendingShip': 'pendingShip',  // 待发货
                'pendingReceive': 'pendingReceive', // 待收货
                'refund': 'refund',           // 退款/售后
                'allOrders': 'all'             // 全部订单
            };

            // 跳转到订单页面，并传递状态参数
            this.$router.push({
                path: '/order',
                query: {
                    status: statusMap[orderKey] || 'all'  // 默认显示全部订单
                }
            });
        },
        handleFunctionClick(funcKey) {
            console.log(`点击功能区: ${funcKey}`);
        },
        goToPointsMall() {
            console.log('进入积分商城');
        },
        goToDetail() {
            // 可跳转商品详情页
            this.$router.push({ path: '/detail' });
        },
        addToCart(item) {
            console.log(`加入购物车: ${item.title}`);
            // 这里可以添加购物车逻辑
        }
    }
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.user-page {
    max-width: 450px;
    margin: 0 auto;
    background-color: #f8f8f8;
    padding: 60px 16px 20px 16px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.top-box {
    position: relative;
    background-image: linear-gradient(to bottom, #fcd0be, rgba(188, 247, 192, 0));
    padding: 16px;
    height: 140px;
}

/* 第一行：头像 + 名称手机号 */
.user-info-row {
    display: flex;
    align-items: center;
}

.avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    overflow: hidden;
    background-color: #e0e0e0;
    margin-right: 14px;
    flex-shrink: 0;
    cursor: pointer;
}

.avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.user-name {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 6px;
    text-align: left;
}

.user-phone {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 6px;
    text-align: left;
}

/* 第二行：积分/抵用券 左右卡片 */
.stat-card {
    display: flex;
    position: absolute;
    left: 16px;
    right: 16px;
    bottom: -50px;
    background: #ffffff;
    border-radius: 16px;
    padding: 14px 0;
    text-align: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
}

.stat-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    padding: 0 20px;
}

.stat-number {
    font-size: 16px;
    font-weight: 700;
    color: #000000;
    margin-bottom: 6px;
}

.stat-label {
    font-size: 12px;
    color: #333333;
    font-weight: 400;
}

/* 第三行：订单状态区域 */
.order-status-row {
    display: flex;
    justify-content: space-between;
    background: #fff;
    border-radius: 20px;
    padding: 14px 12px;
    margin-bottom: 12px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
}

.order-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    cursor: pointer;
    transition: opacity 0.2s;
}

.order-item:active {
    opacity: 0.6;
}

.order-icon {
    width: 26px;
    height: 26px;
    margin-bottom: 6px;
}

.order-text {
    font-size: 11px;
    font-weight: 500;
    color: #2c2c2e;
}

/* 第四行：功能区 */
.function-row {
    display: flex;
    justify-content: space-between;
    background: #fff;
    border-radius: 20px;
    padding: 14px 12px;
    margin-bottom: 16px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
}

.function-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    cursor: pointer;
    transition: opacity 0.2s;
}

.function-item:active {
    opacity: 0.6;
}

.func-icon {
    width: 26px;
    height: 26px;
    margin-bottom: 6px;
}

.func-text {
    font-size: 11px;
    font-weight: 500;
    color: #2c2c2e;
}

/* 积分商城banner */
.points-mall-banner {
    margin-bottom: 20px;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
}

/* 你可能想买 标题 */
.section-title {
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.section-icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
}

.title-text {
    font-size: 16px;
    font-weight: 700;
    color: #333333;
    position: relative;
}

/* 两列网格布局 */
.goods-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

/* 商品卡片样式 - 与首页完全一致 */
.product-card {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: auto;
    cursor: pointer;
    transition: transform 0.2s;
}

.product-card:active {
    transform: scale(0.98);
}

.product-img {
    width: 100%;
    height: auto;
    display: block;
    background: #e9e9e9;
}

.product-info {
    padding: 8px 6px;
}

.product-title {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 1.4;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
}

.product-desc {
    margin: 6px 0;
    font-weight: 300;
    font-size: 10px;
    color: #666;
    text-align: left;
}

/* 价格行样式 - 与首页一致 */
.price-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 6px;
    margin: 8px 0 4px;
    padding: 0 10px 0 5px;
}

.add {
    width: 17px;
    height: 17px;
    background: #06CF33;
    border-radius: 50%;
    line-height: 17px;
    text-align: center;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    transition: background 0.2s;
}

.add:active {
    background: #05b52d;
    transform: scale(0.94);
}

.current-price {
    font-size: 18px;
    font-weight: 800;
    color: #ff3b2f;
}

.old-price {
    font-size: 11px;
    color: #aaa;
    text-decoration: line-through;
}

/* 小屏幕适配 */
@media (max-width: 400px) {
    .user-page {
        padding: 12px;
    }

    .order-icon,
    .func-icon {
        width: 24px;
        height: 24px;
    }

    .order-text,
    .func-text {
        font-size: 10px;
    }

    .current-price {
        font-size: 16px;
    }

    .goods-grid {
        gap: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/User.vue